<template>
  <div class="page__info a-page">
    <div style="background-color:white; padding:10px; border-radius: 4px; overflow: hidden">
      <el-row>
        <el-col :sm="8">
          <el-tabs v-model="activeName">
            <el-tab-pane :label="$t('base.profile')" name="0">
              <div style="margin-top: 20px"></div>

              <p class="text-title" style="margin-top:0!important;">{{ $t('base.username') }}</p>
              <el-input size="mini" readonly v-model="$store.state.userInfo.username"></el-input>
              <p class="text-title">{{ $t('base.display_name') }}</p>
              <el-input size="mini" v-model="update_profile.form.display_name"></el-input>
              <p class="text-title">{{ $t('base.phone_number') }}</p>
              <el-input size="mini" v-model="update_profile.form.phone"></el-input>
              <p class="text-title">Email</p>
              <el-input size="mini" v-model="update_profile.form.email"></el-input>
              <p class="text-title">{{ $t('base.current_password') }}</p>
              <el-input type="password" size="mini" v-model="update_profile.form.password"></el-input>
              <div style="padding:5px;  background-color:whitesmoke; margin-top:10px; border-radius: 4px;">
                {{ $t('profile.note1') }}
              </div>
              <div style="padding-top:20px;" class="text-right">
                <el-button size="mini" icon="el-icon-check" type="primary" :loading="update_profile.loading"
                           @click="m__try_update_profile"> {{ $t('base.update') }}
                </el-button>
              </div>
            </el-tab-pane>
            <el-tab-pane :label="$t('base.change_password')" name="1">
              <div style="margin-top: 20px"></div>

              <strong class="text-title text-danger">*{{ $t('base.change_password_note') }}</strong>
              <br>
              <br>

              <p class="text-title" style="margin-top:0!important;">{{ $t('base.current_password') }}</p>
              <el-input type="password" size="mini" v-model="update_password.form.current_password"></el-input>
              <p class="text-title">{{ $t('base.new_password') }}</p>
              <el-input type="password" size="mini" v-model="update_password.form.new_password"></el-input>
              <p class="text-title">{{ $t('base.confirm_password') }}</p>
              <el-input type="password" size="mini" v-model="update_password.form.confirm_password"></el-input>
              <div style="padding-top:20px;" class="text-right">
                <el-button size="mini" icon="el-icon-check" type="primary"
                           :loading="update_password.loading" @click="m__try_update_password"> {{ $t('base.update')}}
                </el-button>
              </div>
            </el-tab-pane>
          </el-tabs>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
export default {
  name: 'page__info',

  data() {
    return {
      activeName: '1',
      update_profile: {
        loading: false,
        form: {
          username: '',
          display_name: '',
          email: '',
          phone: '',
          password: ''
        }
      },
      update_password: {
        loading: false,
        form: {
          current_password: '',
          new_password: '',
          confirm_password: ''
        }
      }
    }
  },

  beforeMount() {
    this.activeName = this.$route.query.tab || '0'

    this.update_profile.form = {
      ...this.$store.state.userInfo,
      password: ''
    }
  },

  methods: {
    m__try_update_profile() {
      this.$confirm(`Bạn có chắc muốn cập nhật thông tin cá nhân của mình không?`, '', {
        type: 'warning',
        confirmButtonText: this.$t('base.confirm'),
        cancelButtonText: this.$t('base.cancel')
      })
        .then(() => {
          this.update_profile.loading = true
          this.$http.post(this.API.store_account__change_profile, this.update_profile.form, this.cf())
            .then(resp => {
              this.update_profile.loading = false
              this.ntf_s(resp)
              this.EB.$emit('update_profile')
            })
            .catch(error => {
              this.update_profile.loading = false
              this.ntf_w(error)
            })
        })
        .catch(error => {

        })
    },

    m__try_update_password() {
      this.$confirm(`Cập nhật mật khẩu sẽ phải đăng nhập lại, bạn có chắc vẫn muốn thay đổi chứ?`, '', {
        type: 'warning',
        confirmButtonText: this.$t('base.confirm'),
        cancelButtonText: this.$t('base.cancel')
      })
        .then(() => {
          this.update_password.loading = true
          this.$http.post(this.API.store_account__change_password, this.update_password.form, this.cf())
            .then(resp => {
              this.ntf_s(resp)
              this.update_password.loading = false
              this.$store.dispatch('set__user_info', {})
              this.$router.push('/login')
            })
            .catch(error => {
              this.ntf_w(error)
              this.update_password.loading = false
            })
        })
        .catch(() => {
        })
    }
  }
}
</script>

<style></style>



// WEBPACK FOOTER //
// src/pages/info/index.vue